import { AvatarProps } from '@/types/cms';
import Image from 'next/image';
import React from 'react';

import Avatar from '@material-ui/core/Avatar';

interface AuthorAvatarProps {
  avatar: AvatarProps;
  className?: string;
  altText?: string;
}

export const AuthorAvatar = ({ className, avatar, altText }: AuthorAvatarProps) => {
  const imageUrl = avatar.formats ? avatar.formats.thumbnail.url : avatar.url;
  return imageUrl ? (
    <Avatar className={className} data-testid={avatar.formats ? 'formatted' : 'noFormat'}>
      <Image
        alt={altText}
        src={imageUrl}
        layout="fixed"
        objectFit="cover"
        quality={30}
        height={86}
        width={86}
      />
    </Avatar>
  ) : null;
};
